export default __webpack_public_path__ + "static/media/73.e8d68a98.png";